import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TabNavigation from './TabNavigation';
import { Skeleton, Stack, styled, useMediaQuery, useTheme } from '@mui/material';

import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AgricultureOutlinedIcon from '@mui/icons-material/AgricultureOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';
import VisaResult from '../../../../Pages/ResultPages/VisaResult';
import StateResult from '../../../../Pages/ResultPages/StateResult';
import DetailResult from '../../../../Pages/ResultPages/DetailResult';
import DamaResult from '../../../../Pages/ResultPages/DamaResult';
import BacklogResult from '../../../../Pages/ResultPages/BacklogResult';
import { ApiUrls } from '../../../Utils/globalVariables';
import useFetch from '../../../../Service/Hooks/useFetch';
import GeneralTable from '../../Table/TableGeneral';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TaskResult from '../../../../Pages/ResultPages/TaskResult';
import { BacklogTableTitle, TabMainTitle } from '../../Typography/title';


const NavigationtabData = [
    {
        Id: 1,
        Title: "شرایط ویزا",
        Icon: <CheckCircleOutlineIcon sx={{fontSize: "2rem"}} />
    },
    {
        Id: 2,
        Title: "ایالت ها و مناطق",
        Icon: <MapOutlinedIcon sx={{fontSize: "2rem"}} />
    },
    {
        Id: 3,
        Title: "جزئیات ایالت ها و مناطق",
        Icon: <FormatListBulletedOutlinedIcon sx={{fontSize: "2rem"}} />
    },
    {
        Id: 4,
        Title: "وظایف",
        Icon: <AutoAwesomeIcon sx={{fontSize: "2rem"}} />
    },

    // {
    //     Id: 4,
    //     Title: "شرح وظایف",
    //     Icon: <AttachMoneyOutlinedIcon sx={{fontSize: "2rem"}} />
    // },
    {
        Id: 5,
        Title: "بک لاگ",
        Icon: <MarkAsUnreadIcon sx={{fontSize: "2rem"}} />
    },

    {
        Id: 6,
        Title: "لیست رشته ها",
        Icon: <SortByAlphaIcon sx={{fontSize: "2rem"}} />
    },
    // {
    //     Id: 7,
    //     Title: "DAMA",
    //     Icon: <AgricultureOutlinedIcon sx={{fontSize: "2rem"}} />
    // },
]


export default function NavigationTab({ code }) {

    const [{response: taskRes, isLoading: taskLoad, error: taskError}, doFetchTask] = useFetch(ApiUrls.GetTask, "get", true)
    const [{response, isLoading, error}, doFetch] = useFetch(ApiUrls.VisaOption, "get", true)

    const theme = useTheme()

    const isMobilepoint = useMediaQuery(theme.breakpoints.down("md"))

    React.useEffect(() => {
        if(code) {
            doFetchTask({id: code})
        }
    }, [code])

    React.useEffect(() => {
        doFetch()
    }, [])

    const [value, setValue] = React.useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    if(code) {
        return (
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: '#39b54a', display: "flex", justifyContent: "center" }}>
                    <CustomTabList sx={{direction: "rtl !important"}} value={value} onChange={handleChange} variant={isMobilepoint ? "scrollable" : "standard"} scrollButtons allowScrollButtonsMobile >
                        {
                            
                            NavigationtabData.map((val, i) => {
                                return (
                                    <CustomTab key={val.Id} label={
                                        <Stack spacing={1} alignItems="center">
                                            {val.Icon}
                                            {!isMobilepoint && <Typography variant='h4' fontWeight="normal">{val.Title}</Typography>}
                                        </Stack>
                                    } />
                                )
                            })
                        }
                    </CustomTabList>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <TabMainTitle sx={{mb: 4}}>انواع ویزا های در دسترس برای این شغل</TabMainTitle>
                    <VisaResult code={code} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <TabMainTitle sx={{mb: 4}}>جدول خلاصه ایالت/منطقه</TabMainTitle>
                    <StateResult code={code} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <TabMainTitle sx={{mb: 4}}>جزئیات واجد شرایط بودن ایالت/منطقه</TabMainTitle>
                    <DetailResult code={code} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                    <TaskResult data={taskRes} loading={taskLoad} code={code} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                    <TabMainTitle sx={{mb: 4}}>مجموعه مهارت های EOI</TabMainTitle>
                    <BacklogResult code={code} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={5}>
                    <TabMainTitle sx={{mb: 4}}>لیست رشته های مورد نیاز منطقه 2023-2024</TabMainTitle>
                    {
                        isLoading ?
                            <>
                                
                                <GeneralTable 
                                    section="anzsco"
                                    data={response}
                                />
                            </>
                        : <Skeleton sx={{width: "100%", height: "130px", my: 3}} variant="rounded" />
                    }
                </CustomTabPanel>
                {/* <CustomTabPanel value={value} index={5}>
                    <DamaResult />
                </CustomTabPanel> */}
            </Box>
        )
    }

}


//Custom tabs for better navigating
function CustomTabPanel({ children, value, index, ...other }) {

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

//Custom tabs
const CustomTabList = styled(Tabs)(
    ({ theme }) => `

    `
)

const CustomTab = styled(Tab)(
    ({ theme }) => `

        text-align: center;
        border-radius: 12px 12px 0 0;
        padding: 20px 36px;
        text-transform: none;
        transition: 0.4s;
        margin: 0 0.25rem;
        &.Mui-selected {
            color: white !important;
            background: ${theme.palette.primary.main};
        }
        & .MuiTypography-root {
            font-size: 16px;
        }

    `
)
